var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22 22"}},_vm.$listeners),[_c('path',{attrs:{"fill":"#1d232d","d":"M10 14.5a1 1 0 112 0 1 1 0 01-2 0zM11 6a1 1 0 011 1v4a1 1 0 01-2 0V7a1 1 0 011-1zM0 11C0 4.925 4.925 0 11 0s11 4.925 11 11-4.925 11-11 11S0 17.075 0 11zm20 0a9 9 0 10-18 0 9 9 0 0018 0z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }